import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
import { Phone, Mail, MapPin } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-white" data-id="element-252">
      {/* Hero Section */}
      <section className="py-20 bg-neutral-50" data-id="element-253">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-254">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-255">
            <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6" data-id="element-256">
              Contact NTA Taekwondo
            </h1>
            <p className="text-xl text-neutral-600 leading-relaxed" data-id="element-257">
              Have a question about classes for kids, teens, or adults? Send us
              a message and our team will get back to you quickly.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section className="py-20" data-id="element-258">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-259">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-260">
            {/* Contact Information */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-261">
              <h2 className="text-3xl font-bold text-neutral-900 mb-8" data-id="element-262">
                Get In Touch
              </h2>

              <div className="space-y-6" data-id="element-263">
                <a href="tel:9725323400" className="flex items-start gap-4 p-4 bg-neutral-50 rounded-lg hover:bg-neutral-100 transition-colors" data-id="element-264">
                  <Phone className="w-6 h-6 text-red-700 flex-shrink-0 mt-1" data-id="element-265" />
                  <div data-id="element-266">
                    <div className="font-semibold text-neutral-900 mb-1" data-id="element-267">
                      Phone
                    </div>
                    <div className="text-neutral-600" data-id="element-268">(972) 532-3400</div>
                  </div>
                </a>

                <a href="mailto:ntataekwondo@gmail.com" className="flex items-start gap-4 p-4 bg-neutral-50 rounded-lg hover:bg-neutral-100 transition-colors" data-id="element-269">
                  <Mail className="w-6 h-6 text-red-700 flex-shrink-0 mt-1" data-id="element-270" />
                  <div data-id="element-271">
                    <div className="font-semibold text-neutral-900 mb-1" data-id="element-272">
                      Email
                    </div>
                    <div className="text-neutral-600" data-id="element-273">
                      ntataekwondo@gmail.com
                    </div>
                  </div>
                </a>

                <div className="flex items-start gap-4 p-4 bg-neutral-50 rounded-lg" data-id="element-274">
                  <MapPin className="w-6 h-6 text-red-700 flex-shrink-0 mt-1" data-id="element-275" />
                  <div data-id="element-276">
                    <div className="font-semibold text-neutral-900 mb-1" data-id="element-277">
                      Address
                    </div>
                    <div className="text-neutral-600" data-id="element-278">
                      3000 Grapevine Mills Pkwy
                      <br data-id="element-279" />
                      Grapevine, Texas 76051
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-280">
              <div className="bg-white border border-neutral-200 rounded-xl p-8 shadow-lg" data-id="element-281">
                <h2 className="text-2xl font-bold text-neutral-900 mb-6" data-id="element-282">
                  Send Us a Message
                </h2>

                <form onSubmit={handleSubmit} className="space-y-5" data-id="element-283">
                  <div data-id="element-284">
                    <label htmlFor="firstName" className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-285">
                      First Name *
                    </label>
                    <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" data-id="element-286" />
                  </div>

                  <div data-id="element-287">
                    <label htmlFor="lastName" className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-288">
                      Last Name *
                    </label>
                    <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" data-id="element-289" />
                  </div>

                  <div data-id="element-290">
                    <label htmlFor="email" className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-291">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" data-id="element-292" />
                  </div>

                  <div data-id="element-293">
                    <label htmlFor="phone" className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-294">
                      Phone Number *
                    </label>
                    <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent" data-id="element-295" />
                  </div>

                  <div data-id="element-296">
                    <label htmlFor="message" className="block text-sm font-semibold text-neutral-700 mb-2" data-id="element-297">
                      Message *
                    </label>
                    <textarea id="message" name="message" required rows={5} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent resize-none" data-id="element-298" />
                  </div>

                  <button type="submit" className="w-full bg-red-700 text-white font-bold uppercase tracking-wide py-4 px-8 rounded-sm hover:bg-red-800 transition-colors shadow-lg" data-id="element-299">
                    Send Message
                  </button>

                  <p className="text-sm text-neutral-600 text-center" data-id="element-300">
                    Fast response • No pressure
                  </p>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-neutral-50" data-id="element-301">
        <div className="container mx-auto px-4" data-id="element-302">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-303">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4" data-id="element-304">
              Find Us at Grapevine Mills
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-5xl mx-auto" data-id="element-305">
            <div className="relative w-full h-[450px] rounded-xl overflow-hidden shadow-2xl" data-id="element-306">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3347.4320270404673!2d-97.04444572359886!3d32.96600187430282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c2b8692517bab%3A0xebef98052bff8153!2s3000%20Grapevine%20Mills%20Pkwy%2C%20Grapevine%2C%20TX%2076051!5e0!3m2!1sen!2sus!4v1767713370561!5m2!1sen!2sus" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-307"></iframe>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white" data-id="element-308">
        <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-309">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-310">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-8" data-id="element-311">
              Ready to Get Started?
            </h2>
            <Button href="/signup" className="text-lg px-10 py-4" data-id="element-312">
              Easy Class Signup
            </Button>
          </motion.div>
        </div>
      </section>
    </div>;
}